module.exports = __webpack_public_path__ + "img/image_step_2.11a83824.png";